import './SelectionList.css';

export default function SelectionList({ items, loading, loadingLabel, children }) {
    const waitingForData = loading && items.length === 0;
    return <div className="selection-list-frame" aria-busy={waitingForData}>
        {waitingForData && <span className="selection-loading-label" role="status">{loadingLabel}</span>}
        <ul className="selection-list flex flex-row flex-wrap items-center justify-center gap-2 py-4">
            {waitingForData ? Array.from({ length: 8 }, (_, index) => (
                <li key={index} className="selection-skeleton" aria-hidden="true" />
            )) : children}
        </ul>
    </div>;
}
